import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable, switchMap, tap } from 'rxjs';
import { LanguageService, SmartbookHttpService } from 'shared/domain';
import { tapAllResponses } from 'shared/util-common';

import { Guideline } from '@treetop/shared/model';

import { ExpandService } from '../../../../../shared/util-common/src/lib/expand.service';

interface GuidelinesState {
  readonly guideline?: Guideline;
  readonly loading: boolean;
  readonly error: boolean;
  readonly hasUpdateMessage: boolean;
}

@Injectable()
export class SmartbookGuidelinesStore extends ComponentStore<GuidelinesState> {
  private http = inject(SmartbookHttpService);
  private languageService = inject(LanguageService);
  private expandService = inject(ExpandService);

  public guideline$ = this.select((state) => state.guideline);
  public loading$ = this.select((state) => state.loading);

  constructor() {
    super(initialState);
  }

  public readonly getPreviewGuideline = this.effect((params$: Observable<{ uniqueId: string; version: string }>) => {
    return params$.pipe(
      tap(() => this.patchState({ loading: true })),
      switchMap((params) =>
        this.http.getSmartbookPreviewByUniqueId(params.uniqueId, params.version).pipe(
          tapAllResponses<Guideline, HttpErrorResponse>(
            (guideline) => {
              this.patchState({ guideline, loading: false });
              this.prepareServices(guideline);
            },
            () => this.patchState({ loading: false }),
          ),
        ),
      ),
    );
  });

  private prepareServices(guideline: Guideline): void {
    this.expandService.expandAll();
    this.languageService.language.setState(guideline.languageCode as string);
  }
}

const initialState: GuidelinesState = {
  guideline: undefined,
  loading: false,
  error: false,
  hasUpdateMessage: false,
};
